import type { TutorialStepDef } from '../types';
import { Step1Intro } from './Step1Intro';
import { Step2Order } from './Step2Order';
import { Step3Scoring } from './Step3Scoring';
import { Step4Bonuses } from './Step4Bonuses';
import { Step5Flow } from './Step5Flow';
import { Step6Sandbox } from './Step6Sandbox';

export const tutorialSteps: TutorialStepDef[] = [
  { id: 'intro',   render: () => <Step1Intro /> },
  { id: 'order',   render: () => <Step2Order /> },
  { id: 'scoring', render: () => <Step3Scoring /> },
  { id: 'bonuses', render: () => <Step4Bonuses /> },
  { id: 'flow',    render: () => <Step5Flow /> },
  { id: 'sandbox', render: () => <Step6Sandbox /> },
];
